import { topicItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-9">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">热门话题</h2>
          <p className="mt-2 text-sm text-foreground-500">大家都在讨论的电影话题，点击探索更多</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item) => (
            <a
              key={item.id}
              href={`#topics`}
              onClick={(e) => e.preventDefault()}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full border text-sm cursor-pointer no-underline transition-colors ${
                item.color === 'accent'
                  ? 'bg-accent-100 border-accent-200 text-accent-700 hover:bg-accent-200'
                  : item.color === 'secondary'
                  ? 'bg-secondary-100 border-secondary-200 text-secondary-700 hover:bg-secondary-200'
                  : 'bg-primary-100 border-primary-200 text-primary-700 hover:bg-primary-200'
              }`}
            >
              <span className="font-medium whitespace-nowrap">{item.name}</span>
              <span className="text-xs opacity-70 whitespace-nowrap">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}